import { Component, OnInit,Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyService } from '../../../services/currency.service';
import { Router } from '@angular/router';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input('Monedas') Monedas;  

  constructor(public translate: TranslateService, public _currencyService:CurrencyService){
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
    translate.use('es');
    this._currencyService.getMoneda().then(data => { this.Monedas= data; });
  }

  ngOnInit()
  {
    console.log('Entro al Header');
  }

  changeLang(lang: string)
  {
    this.translate.use(lang);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/general/header/header.component.ts